<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="../../assets/images/pages/coming-soon.svg"
        alt="graphic-404"
        class="mx-auto mb-4 max-w-full"
      />
      <h3 class="sm:mx-0 mx-4 mb-12 mt-5 text-2xl d-theme-heading-color">
        {{ msg || 'Página não encontrada!' }}
      </h3>
      <vs-button size="large" :to="urlBack || '/dashboard'">voltar</vs-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['msg', 'urlBack'],
  data() {
    return {
      error: false,
      filtro: null,
      errorMsg: 'Página não encontrada!',
      returnTo: '/',
    };
  },
  methods: {},
  mounted() {},
  components: {},
};
</script>
